import { Mail, Phone, Facebook } from "lucide-react";

const INSTAGRAM_PATH =
  "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z";

function InstagramIcon({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d={INSTAGRAM_PATH} />
    </svg>
  );
}

// Semplici link: niente Chakra nel footer, che è guscio e si carica su ogni pagina
const SOCIAL_LINK_CLASS =
  "grid h-11 w-11 place-items-center rounded-full border border-white/[.16] bg-white/[.05] text-white/[.68] transition-colors hover:border-white/[.32] hover:text-white/[.94] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring";

export function SocialIcons() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <a href="https://www.instagram.com/triestestorica.it/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={SOCIAL_LINK_CLASS}>
        <InstagramIcon size={17} />
      </a>
      <a href="https://www.facebook.com/TriesteStorica/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={SOCIAL_LINK_CLASS}>
        <Facebook size={17} strokeWidth={1.75} />
      </a>
      <a href="mailto:admin@triestestorica.it" aria-label="Email" className={SOCIAL_LINK_CLASS}>
        <Mail size={17} strokeWidth={1.75} />
      </a>
      <a href="tel:+393483601758" aria-label="Telefono" className={SOCIAL_LINK_CLASS}>
        <Phone size={17} strokeWidth={1.75} />
      </a>
    </div>
  );
}
